var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoOffRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.26986L3.41 1.85986L21.14 19.5899L19.73 20.9999L16.55 17.8199C16.39 17.9199 16.21 17.9999 16 17.9999H4C3.45 17.9999 3 17.5499 3 16.9999V6.99986C3 6.44986 3.45 5.99986 4 5.99986H4.73L2 3.26986ZM21 6.49986V16.6099L10.39 5.99986H16C16.55 5.99986 17 6.44986 17 6.99986V10.4999L21 6.49986Z",
    fill: "#FF4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOffRed);
export default __webpack_public_path__ + "static/media/video-off-red.4fb13c34ce353155ff9e44ddf963cce7.svg";
export { ForwardRef as ReactComponent };